import { Check } from "lucide-react";

export function ChannelOption({ id, label, icon: Icon, disabled, hint, active, onSelect }) {
  return (
    <button
      type="button"
      role="radio"
      aria-checked={active}
      disabled={disabled}
      onClick={() => !disabled && onSelect(id)}
      data-testid={`publish-channel-${id}`}
      className={`w-full text-left flex items-center gap-3 border rounded-xl p-3.5 transition-colors duration-150 ${
        disabled
          ? "opacity-50 cursor-not-allowed border-slate-200 bg-slate-50"
          : active
            ? "border-indigo-400 bg-indigo-50/60 ring-2 ring-indigo-200"
            : "border-slate-200 hover:border-slate-300 bg-white"
      }`}
    >
      <span className={`w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0 ${
        active ? "bg-indigo-500 text-white" : "bg-slate-100 text-slate-500"
      }`}>
        <Icon size={16} />
      </span>
      <span className="min-w-0 flex-1">
        <span className="block text-sm font-semibold text-[#0f172a]">{label}</span>
        <span className="block text-xs text-slate-400 mt-0.5">{hint}</span>
      </span>
      {active && !disabled && (
        <Check size={16} className="text-indigo-500 flex-shrink-0" />
      )}
    </button>
  );
}
